// extracted by mini-css-extract-plugin
module.exports = {"StudiesProgrammeForm":"style_StudiesProgrammeForm__3290d","wrapper":"style_wrapper__2dgkG","column":"style_column__2nfX0","wrapperColumn":"style_wrapperColumn__MhDYk"};